import {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import {isAgentsEnabled} from '@github-ui/repo-app-flags'

// Repo Agents' routes can be registered under the unified `repo` app when the
// `repo_app_agents` flag is on. The app's identity stays `repo-agents`, but in
// that case its query keys must use `repo` so they match the running app. The
// resolver is only evaluated when a query key is built (runtime), so it can
// safely read the flag.
export const repoAgentsAppBuilder = DataRouterApplicationBuilder.create('repo-agents', {
  queryKeyAppName: () => (isAgentsEnabled() ? 'repo' : 'repo-agents'),
})
